import {
    SidebarAwareCenteredSnackbar,
    SidebarAwareCenteredSnackbarProps,
} from '@map/snackbars/SidebarAwareCenteredSnackbar';

export default function InteractionInstructionsSnackbar({
    instructions,
    ...props
}: {
    instructions:
        | {
              message: React.ReactNode;
              action?: React.ReactNode;
          }
        | undefined;
} & SidebarAwareCenteredSnackbarProps) {
    return (
        <SidebarAwareCenteredSnackbar
            sx={(theme) => ({
                [theme.breakpoints.down('md')]: {
                    display: 'none',
                },
            })}
            open={Boolean(instructions)}
            message={instructions?.message}
            action={instructions?.action}
            {...props}
        />
    );
}
